// eslint-disable-next-line import/no-anonymous-default-export
export default {
  "doctorName": "डॉक्टर का नाम",
  "Speciality": "Speciality",
  "Fees": "Fees",
  "City": "City",
  "State": "State"
}